export const BACKEND_URLS = Object.freeze({
    "PROD": "https://go.salarispayroll.com",
    "SHIFT4_PROD": "https://go.salarispayroll.com",
    "DEMO": "https://demo-api.salarispayroll.cloud",
    "LOCAL": "https://pg-2.salarispayroll.cloud",
    "PG-1": "https://pg-1.salarispayroll.cloud",
    "PG-2": "https://pg-2.salarispayroll.cloud",
    "PG-3": "https://pg-3.salarispayroll.cloud",
    "PG-4": "https://pg-4.salarispayroll.cloud",
    "PG-5": "https://pg-5.salarispayroll.cloud",
    "PG-6": "https://pg-6.salarispayroll.cloud",
    "PG-7": "https://pg-7.salarispayroll.cloud",
    "PG-8": "https://pg-8.salarispayroll.cloud",
});
